import { render, staticRenderFns } from "./SocialMediaLinks.vue?vue&type=template&id=0dfc7cac&scoped=true"
import script from "./SocialMediaLinks.vue?vue&type=script&lang=js"
export * from "./SocialMediaLinks.vue?vue&type=script&lang=js"
import style0 from "./SocialMediaLinks.vue?vue&type=style&index=0&id=0dfc7cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfc7cac",
  null
  
)

export default component.exports